// extracted by mini-css-extract-plugin
export default {"scrollable":"App_scrollable__91FMg"};